export default __webpack_public_path__ + "static/kubernetes-8718374bbea00cec942da73d84c2b466.svg";